module.exports = 'ttb.dashboard.userStoryStatuses.component';

angular.module(module.exports, [])
    .component('userStoryStatuses', {
        template: `<div ng-cloak class="card-box">
                    <h4 class="text-dark  header-title m-t-0 m-b-30" translate>DashBoard_Sprint_Statuses_Pie</h4>
                        <div class="widget-chart text-center">
                            <div id="userStoryStatusesChart">
                                <div ng-show="$ctrl.loading" class ="loader-1"></div>
                                <svg style="height:230px;width:100%"></svg>
                            </div>
                        </div>
                 </div>`,
        controller: UserStoryStatuses,
        bindings: {
            team: '<'
        }
    });

function UserStoryStatuses($http, $timeout, userStoryStatusesUrl) {
    this.$onChanges = (changes) => {
        if (changes.team) {
            if (changes.team.currentValue !== undefined) {
                this.load(changes.team.currentValue);
            }
            else {
                this.update([]);
            }
        }
    }

    this.update = (data) => {
        nv.addGraph(function () {
            var chart = nv.models.pieChart()
                    .x(function (d) { return d.label })
                    .y(function (d) { return d.value })
                    .showLabels(true) //Display pie labels
                    .labelThreshold(.05) //Configure the minimum slice size for labels to show up
                    .labelType("percent") //Configure what type of data to show in the label. Can be "key", "value" or "percent"
                    .donut(true) //Turn on Donut mode. Makes pie chart look tasty!
                    .donutRatio(0.35) //Configure how big you want the donut hole size to be.
                ;
                chart.tooltip.valueFormatter(function (d) { return d }); // This will round the value without decimal.

            d3.select("#userStoryStatusesChart svg")
                .datum(data)
                .transition()
                .duration(350)
                .call(chart);

            return chart;
        });
    }

    this.load = (team) => {
        this.loading = true;
        this.info = 'loading...';

        $http.get(userStoryStatusesUrl, { params: { teamId: team ? team.id : null, timestamp: new Date() } })
            .then(response => {
                    this.loading = false;
                    this.update(response.data || []);
                },
                () => {
                    this.loading = false;
                });
    }
}
UserStoryStatuses.$inject = ['$http', '$timeout', 'userStoryStatusesUrl'];


// WEBPACK FOOTER //
// ./components/user-story-statuses/user-story-statuses.component.js